import React from "react";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  element: React.ReactElement;
  permission: string; 
  acessos: string[]; 
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  element,
  permission,
  acessos
}) => {
  if (acessos.includes("*")) {
    return element;
  }

  return acessos.includes(permission)
    ? element
    : <Navigate to="/sem-acesso" replace />;
};

export default ProtectedRoute;
